import Home from './Pages/Home';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import './App.css';
import TvLogin from './Pages/User/TvLogin';
import NewsDetail from './Pages/NewsDetail';
import Lesson from './Pages/Lesson';
import Contact from './Pages/Contact';
import LessonDetail from './Pages/LessonDetail';


function App() {
  return (
    <BrowserRouter>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lesson" element={<Lesson />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news/detail" element={<NewsDetail />} />
          <Route path="/lesson/detail" element={<LessonDetail />} />
          <Route path="/tvlogin" element={<TvLogin />} />
        </Routes>
      </QueryParamProvider>
    </BrowserRouter>
  );
}

export default App;
